module.exports = __webpack_public_path__ + "img/lk-mode-credit-card-green.c36ce910.svg";